import { LOGIN_SUCCESS, LOGOUT_REQUEST, UPDATE_USER } from "../Actions/actionType";

const INITIAL_STATE = {
  access_token: "",
  isLogin: false,
  user: null,
  mode: "light",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        user: action.payload?.data.user,
        isLogin: true,
        access_token: action.payload?.token,
      };
      break;

    case UPDATE_USER:
      console.log(action.payload);
      return {
        ...state,
        user: action.payload,
      };
      break;

    case LOGOUT_REQUEST:
      return {
        ...state,
        access_token: "",
        isLogin: false,
        user_type: "",
        user: null,
      };
    default:
      return state;
  }
};
